/** a same-origin LEAD path, so a `?redirect=` or an SSO `return_path` can never send the browser to another site */
export function isSafeRedirect(target: unknown): target is string {
  return typeof target === 'string' && target.startsWith('/') && !target.startsWith('//') && !target.includes('://');
}
